import { getFirstDecisioningCreativeComponentVariant } from "./getFirstDecisioningCreativeComponentVariant";
import type {
  BuildDecisioningCreativeComponentPreviewTriggerPropertiesHashParams,
  DecisioningCreativeComponentTriggerPropertiesHash,
} from "./types";

/**
 * Builds Decisioning Studio's preview trigger properties from current component selections.
 *
 * @param params DS campaign flag, used components, variant lists, and current selections.
 * @return DS wire-format trigger properties, or undefined when no component has a usable creative.
 */
export const buildDecisioningCreativeComponentPreviewTriggerPropertiesHash = ({
  isDecisioningStudioCampaign,
  usedComponents,
  variantsByComponent,
  selections,
}: BuildDecisioningCreativeComponentPreviewTriggerPropertiesHashParams):
  | DecisioningCreativeComponentTriggerPropertiesHash
  | undefined => {
  if (!isDecisioningStudioCampaign) {
    return undefined;
  }

  const apiTriggerProperties = usedComponents.reduce<Record<string, string>>((properties, componentName) => {
    const explicitSelection = selections[componentName];
    const fallbackSelection = getFirstDecisioningCreativeComponentVariant(variantsByComponent[componentName]);
    const creative = explicitSelection || fallbackSelection;

    if (creative.length > 0) {
      properties[componentName] = creative;
    }

    return properties;
  }, {});

  if (Object.keys(apiTriggerProperties).length === 0) {
    return undefined;
  }

  return { api_trigger_properties: apiTriggerProperties };
};
